const LEVELS = ["Beginner", "Intermediate", "Expert"];

const LEVEL_STYLE = {
  Beginner: "bg-emerald-500 text-white border-emerald-500",
  Intermediate: "bg-amber-500 text-white border-amber-500",
  Expert: "bg-primary text-primary-foreground border-primary",
};

export default function LearningLevelPicker({ label, languages = [], levels = {}, onChange, testid = "level-picker" }) {
  if (!languages.length) return null;
  const setLevel = (lang, lvl) => onChange({ ...levels, [lang]: lvl });
  return (
    <div data-testid={testid}>
      <p className="text-xs tracking-[0.15em] uppercase font-bold text-muted-foreground mb-3">{label}</p>
      <div className="space-y-3">
        {languages.map((lang) => (
          <div key={lang} className="flex flex-wrap items-center justify-between gap-3 rounded-2xl bg-accent/40 px-4 py-3" data-testid={`${testid}-row-${lang.toLowerCase()}`}>
            <span className="font-heading font-bold text-sm">{lang}</span>
            <div className="flex gap-1.5">
              {LEVELS.map((lvl) => {
                const on = (levels[lang] || "Beginner") === lvl;
                return (
                  <button
                    type="button"
                    key={lvl}
                    onClick={() => setLevel(lang, lvl)}
                    data-testid={`${testid}-${lang.toLowerCase()}-${lvl.toLowerCase()}`}
                    className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-all ${on ? LEVEL_STYLE[lvl] : "bg-transparent text-foreground/60 border-border hover:border-primary/40"}`}
                  >
                    {lvl}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
